import { render } from "./SpacesGroup.vue?vue&type=template&id=f8f16308&scoped=true&ts=true"
import script from "./SpacesGroup.vue?vue&type=script&lang=ts"
export * from "./SpacesGroup.vue?vue&type=script&lang=ts"

import "./SpacesGroup.vue?vue&type=style&index=0&id=f8f16308&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f16308"]])

export default __exports__